import { type ChallengeSummary } from '@/lib/types';
import { useGridColumnCount } from './ResponsiveMasonry';

const DEFAULT_VISIBLE_CHALLENGE_ROWS_COUNT = 3;

const useDefaultVisibleChallenges = (
  challenges: ChallengeSummary[],
): ChallengeSummary[] => {
  const gridColumnCount = useGridColumnCount();
  const maxVisibleChallenges =
    gridColumnCount * DEFAULT_VISIBLE_CHALLENGE_ROWS_COUNT;

  if (challenges.length <= maxVisibleChallenges) {
    return challenges;
  }

  return challenges.slice(0, maxVisibleChallenges);
};

export default useDefaultVisibleChallenges;
